import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = [{
  title: 'Ebook Digital 12Metabolismo',
  desc: 'El plan paso a paso de 12 días completo.'
}, {
  title: 'Checklist Diaria',
  desc: 'Mantente en el camino con pasos claros.'
}, {
  title: 'Diario de Energía',
  desc: 'Registra tu progreso día a día.'
}, {
  title: 'Recetas de 3 Colores',
  desc: 'Comidas rápidas para nutrir tu metabolismo.'
}, {
  title: 'Bonus Exclusivo',
  desc: 'Rutina de Estiramientos Nocturnos para optimizar tu descanso.'
}];
export function BenefitsSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#F0FDF4]" data-id="element-28">
      <div className="max-w-7xl mx-auto" data-id="element-29">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-30">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative order-2 lg:order-1" data-id="element-31">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-32">
              <img src="https://cdn.magicpatterns.com/uploads/tvC3xdBkr7aT2MzepMnwg4/heylloyd-image-1773959229796.png" alt="Portada del Ebook 12Metabolismo en una tablet rodeada de alimentos saludables" className="w-full h-auto object-cover" data-id="element-33" />
            </div>
            {/* Decorative background element */}
            <div className="absolute -top-8 -left-8 w-32 h-32 bg-[#2D8C4E] opacity-10 rounded-full blur-2xl -z-10" data-id="element-34"></div>
            <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-[#F59E0B] opacity-10 rounded-full blur-2xl -z-10" data-id="element-35"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-1 lg:order-2" data-id="element-36">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-8" data-id="element-37">
              Lo Que Obtienes
            </h2>

            <ul className="space-y-6" data-id="element-38">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start" data-id="element-39">
                  <CheckCircle2 className="w-6 h-6 text-[#2D8C4E] flex-shrink-0 mt-1 mr-4" data-id="element-40" />
                  <div data-id="element-41">
                    <h4 className="text-lg font-bold text-[#1A1A1A]" data-id="element-42">
                      {benefit.title}
                    </h4>
                    <p className="text-gray-600 font-sans mt-1" data-id="element-43">
                      {benefit.desc}
                    </p>
                  </div>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}